import { createConsumer } from "@rails/actioncable/src"

export default createConsumer()
